import { Box } from '@chakra-ui/react'

interface IFilterCountBadgeProps {
  count: number
}

/**
 * Active-filter count for a filter trigger. It rides on the corner of the button
 * so the trigger keeps one fixed width — on a phone the label is hidden and the
 * count used to sit inline, which made the button resize as filters were applied.
 * Callers wrap the button in a `position="relative"` box.
 */
const FilterCountBadge = ({ count }: IFilterCountBadgeProps) => {
  if (count <= 0) return null

  return (
    <Box
      position="absolute"
      top="-6px"
      right="-6px"
      minW="16px"
      h="16px"
      px="4px"
      borderRadius="full"
      bg="#4DB3FF"
      color="white"
      fontSize="10px"
      fontWeight={700}
      display="flex"
      alignItems="center"
      justifyContent="center"
      pointerEvents="none"
    >
      {count}
    </Box>
  )
}

export default FilterCountBadge
